var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.0616L9.625 11.8116L13.5625 7.87409M17.5 10.4991C17.5 14.794 12.8153 17.9177 11.1107 18.9121C10.917 19.0251 10.8202 19.0816 10.6835 19.1109C10.5774 19.1337 10.4226 19.1337 10.3165 19.1109C10.1798 19.0816 10.083 19.0251 9.88926 18.9121C8.18472 17.9177 3.5 14.794 3.5 10.4991V6.31449C3.5 5.61492 3.5 5.26514 3.61442 4.96446C3.71549 4.69884 3.87973 4.46184 4.09295 4.27393C4.33431 4.06123 4.66182 3.93841 5.31685 3.69277L10.0084 1.93343C10.1903 1.86522 10.2813 1.83111 10.3749 1.81759C10.4579 1.8056 10.5421 1.8056 10.6251 1.81759C10.7187 1.83111 10.8097 1.86522 10.9916 1.93343L15.6831 3.69277C16.3382 3.93841 16.6657 4.06123 16.907 4.27393C17.1203 4.46184 17.2845 4.69884 17.3856 4.96446C17.5 5.26514 17.5 5.61492 17.5 6.31449V10.4991Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationActive);
export default __webpack_public_path__ + "static/media/verification-active.e5fc4d0e62d5ba4b7dbded48266cd49b.svg";
export { ForwardRef as ReactComponent };